import React, { useContext } from 'react';
import { shape, func, string, bool } from 'prop-types';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';
import { Alert } from '@thd-olt-component-react/alert';
import { CheckNearByStore } from './CheckNearbyStore';
import { productShape } from '../../helpers/pod-fulfillment-utils';
import { UnavailableIcon } from '../../helpers/icon-utils';

export const NoStoreOption = ({
  storeMessage,
  enableNearbyStore,
  product,
  onCheckNearbyStoresClick
}) => {
  const { channel } = useContext(ExperienceContext);
  const { storeName } = useStore();

  const storeNameLink = channel === 'mobile'
    ? <span className="store__primary store__store-name store__text-adjustment">{storeName}</span>
    : (
      <CheckNearByStore
        product={product}
        onCheckNearbyStoresClick={onCheckNearbyStoresClick}
      />
    );

  return (
    <div className="store__message">
      <div className="store__icon">
        <UnavailableIcon />
      </div>
      <div className="store__text-box">
        <div className="store__dark">
          Pickup
        </div>
        <div id="check-nearby-store" className="store__second-line">
          <span className="store__primary">
            {storeMessage}
          </span>
          {enableNearbyStore && storeNameLink}
        </div>
      </div>
    </div>
  );
};

NoStoreOption.propTypes = {
  enableNearbyStore: bool,
  onCheckNearbyStoresClick: func,
  product: shape({ productShape }).isRequired,
  storeMessage: string,
};

NoStoreOption.defaultProps = {
  enableNearbyStore: true,
  onCheckNearbyStoresClick: () => {},
  storeMessage: 'Unavailable',
};

NoStoreOption.displayName = 'NoStoreOption';
